import React from 'react';
import { Waypoint } from 'react-waypoint';
import Comment, { Props } from '../../../Comment/presets/Comment';
import { updateCommentOffsetEveryPage } from '../../helpers';

const OffsetTrackingComment: React.FC<Props & { index?: number }> = props => {
  const onEnter = () => updateCommentOffsetEveryPage(props.comment, props.index);

  return (
    <Waypoint topOffset="-100px" bottomOffset="100%" onEnter={onEnter}>
      {/* div wrapper exists for correct Waypoint measurements */}
      <div>
        <Comment {...props} />
      </div>
    </Waypoint>
  );
};
OffsetTrackingComment.displayName = 'OffsetTrackingComment';

export default OffsetTrackingComment;
